import React from "react";
import { Box,Grid} from "@mui/material";
import"../../../css/PaginaProducto/ProductoEspecifico.css"


export const PortadaProductoEspecifico = ({producto ,categoria}) => {
    const backendURL = process.env.REACT_APP_BACKEND_URL;
    
    return(
        <Box >
            {/* titulo categoria */}
            <Box
            sx={{
                display:"flex",
                alignItems:'center',
                justifyContent:'center',
             
            }}>
                <h1 className="TituloPaginaProducto">{categoria.titulo}</h1>
                <h1 className="Titulo1PaginaProducto">{categoria.titulo1}</h1>
            </Box>
        
            <Box sx={{
                marginTop:'100px',
                 '@media (max-width:600px)': {
        marginTop:'10px',
    },}}>
                <Grid container spacing={2}>
                    <Grid size={{sm:12, md:6}} sx={{
                
                display:"flex",alignItems:'center', justifyContent:'center', flexDirection:'column'
            }}>         
            <Box 
            sx={{
                width:'100%',
                display:'flex',
                alignItems:'flex-end',
                justifyContent:'flex-end'
            }}>
                                     {producto.logo_empresa_maquina && (
        <Box
          className='ImagenLogoEmpresaMaquinaPaginaEspecificas'
          sx={{display:"none",
             '@media (max-width:899px)': {
        display:"flex"
    },
          }}
          
        >
          <img
            src={`${backendURL}/${producto.logo_empresa_maquina}`}
            alt="logo"
            title="logo"
           
          />
        </Box>
      )}
            </Box>
                        <Box className='ImagenProdcutoPaginaEspecificas'>
                            {producto.imagen_producto && (
                                                                <img
                                                                    src={`${backendURL}/${producto.imagen_producto}`}
                                                                    alt="hod"
                                                                    title="hod"
                                                                />
                                                            )}
                        </Box>

        

                        
                    </Grid>
                     <Grid size={{sm:12, md:6}}>
                        <Box>
                            {/* imagen logo maquina */}
                            <Box
                            sx={{
                                display:'flex',
                                alignItems:"center",
                                justifyContent:"flex-end"
                            }}>
                                   <Box className='ImagenLogoEmpresaMaquinaPaginaEspecificas' sx={{display:"flex",
             '@media (max-width:899px)': {
        display:"none"
    },
          }}
          >
                            {producto.logo_empresa_maquina && (
                                                                <img
                                                                    src={`${backendURL}/${producto.logo_empresa_maquina}`}
                                                                    alt="hod"
                                                                    title="hod"
                                                                />
                                                            )}
                        </Box>                             
                            </Box>
                            {/* informacion producto */}
                            <Box className='infoProductoMaquina'>
                                <Box className='contienetitulomaquinaprodcutopagina'>
                                    <h1 className="titulomaquinapaginaespecifico">{producto.titulo_maquina}</h1>
                                    <h1 className="titulo1maquinapaginaespecifico" style={{ color: producto.color || '#1A425B' }}>{producto.nombre_maquina}</h1>
                                </Box>
                                <Box
                                sx={{
                                    width:'70%',
                                    marginTop:'30px',
                                    display: 'flex',
                                    '@media (max-width:408px)': {
        width:'100%',
    }, 
                                }}>
                                    
                                        <Box
                                            sx={{
                                            width: '4px',
                                            backgroundColor: producto.color || '#1A425B',
                                            borderRadius: '4px  4px',
                                            margin:'10px'
                                            }}
                                        />
                                        <Box className="cardvisionproducto">
                                            <h2>{producto.titulo_vision}</h2>
                                            <h4>{producto.descripcion_vision}</h4>
                                        </Box>
                                    

                                </Box>

                                 <Box
                                sx={{
                                    width:'70%',
                                    marginTop:'30px',
                                    display: 'flex',
                                     '@media (max-width:408px)': {
        width:'100%',
    }, 
                                }}>
                                    
                                        <Box
                                            sx={{
                                            width: '4px',
                                            backgroundColor: producto.color || '#1A425B',
                                            borderRadius: '4px  4px',
                                            margin:'10px'
                                            }}
                                        />
                                        <Box className="cardvisionproducto">
                                            <h2>Innovación</h2>
                                            <h4>{producto.texto_innovacion}</h4>
                                        </Box>
                                    

                                </Box>

                            </Box>
                        </Box>
                     </Grid>

                </Grid>
            </Box>
        </Box>
    )
}